import Keycloak from 'keycloak-js';

export const keycloak = new Keycloak(`${window.location.origin}/keycloak.json`);
